import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="w-full bg-navy-dark py-16 md:py-24 px-4" data-id="element-99">
      <div className="max-w-6xl mx-auto" data-id="element-100">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-101">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="order-2 md:order-1" data-id="element-102">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight" data-id="element-103">
              De Papá Primerizo a <span className="text-gold" data-id="element-104">Patriarca</span>:
              El Manual Táctico para Dominar el Primer Año en USA.
            </h1>
            <p className="font-body text-lg md:text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-105">
              El sistema de EE.UU. no viene con instrucciones para papás. Esta
              guía sí.
            </p>
            <CTAButton onClick={scrollToOffer} className="w-full md:w-auto" ariaLabel="Ver oferta del manual" data-id="element-106">
              QUIERO EL MANUAL AHORA
            </CTAButton>
          </motion.div>

          {/* Hero Image */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-1 md:order-2" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/vXtDML3ErQFYeBKLzZRQkA/heylloyd-image-1771657777525.png" alt="Padre táctico sosteniendo a su hijo con bandera americana de fondo" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-108" />
          </motion.div>
        </div>
      </div>
    </section>;
}